import React, { useCallback, useMemo } from "react";
import { SearchableDropdown } from "../../../components";
import {
  ProductRegionOption,
  productRegionOptions,
} from "../../../store/reducers/products/products.types";
import styled from "styled-components";
import colors from "../../../theme/colors";
import { ProductRegion } from "../../../store/reducers/products/products.types";

export default function ProductLinesRegionFilter({
  searchRegions,
  setSearchRegions,
}: {
  searchRegions: ProductRegion[];
  setSearchRegions: React.Dispatch<React.SetStateAction<ProductRegion[]>>;
}) {
  //Determine the selected options
  const valueOptions = useMemo(() => {
    if (!Array.isArray(searchRegions) || searchRegions.length === 0) return [];

    return productRegionOptions.filter((region) =>
      searchRegions.includes(region.value)
    );
  }, [searchRegions, productRegionOptions]);

  // The dropdown will pass back the selected option objects (RegionOption[]).
  // Map those to the array of ProductRegion that your state expects.
  const handleRegionsChange = useCallback(
    (_keys: string[], values: ProductRegionOption[]) => {
      if (!values || values.length === 0) {
        setSearchRegions([]);
        return;
      }
      setSearchRegions(values.map((s) => s.value));
    },
    [setSearchRegions]
  );

  return (
    <Wrapper>
      <Label>{"Filter Region"}</Label>
      <StyledSearchableDropdown
        multiselect
        searchable
        clearable
        name="region"
        placeholder="all regions"
        options={productRegionOptions}
        value={valueOptions}
        handleValueChange={handleRegionsChange}
        noShadow
        noHoverBorder
      />
    </Wrapper>
  );
}
const Wrapper = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
`;

const Label = styled.span`
  color: ${(props) => props.theme.colors.muttedHeadlines};
`;

const StyledSearchableDropdown = styled(SearchableDropdown)<any>`
  border: 1px solid ${colors.tables.borders};
  box-sizing: border-box;
  border-radius: 4px;
  margin: 0 16px 0 8px;
  padding: 1px;
  width: 250px;
  min-width: 131px;
`;
